import { createFileRoute } from '@tanstack/react-router';
import { CarHistoryPage } from '@/features/bookings/CarHistory';

export const Route = createFileRoute('/_app/car-history')({
  component: CarHistoryPage,
  validateSearch: (s: Record<string, unknown>) => ({
    vehicleId: typeof s.vehicleId === 'string' ? s.vehicleId : undefined,
    employeeId: typeof s.employeeId === 'string' ? s.employeeId : undefined,
  }),
});
